






































































































import NextButton from '@/components/shared/NextButton'
import PreviousButton from '@/components/shared/PreviousButton'
import CancelButton from '@/components/shared/CancelButton'
import {MachineSettings, PalletPattern, RobotTypeEnum} from '@/generated/model/models'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { robots } from '@/api/const'
import Units from '@/api/utils/units'

@Component({
  components: {
    NextButton: NextButton,
    PreviousButton: PreviousButton,
    CancelButton: CancelButton
  },
  computed: {
    ...mapGetters('palletpatterns', [
      'selectedEntity',
      'checkName',
      'isNew'
    ]),
    ...mapGetters('machinesettings', ['fixedMachineSettings'])
  }
})
export default class SimpleFormA extends Vue {
  @Prop() private value!: PalletPattern
  @Prop({ required: true }) private parentBus!: Vue
  @Prop() private units!: Units
  @Prop({ required: true }) private machineSettings!: MachineSettings

  private rules: object = {
    required: (v: any) => !!v || this.localText('general.required'),
    min: (v: any) => (v && v.length >= 3) || this.localText('basicStep.minThree'),
    minOne: (v: any) => (v && v >= 1) || this.localText('basicStep.largerOne'),
    ascii: (v: any) => {
      const pattern = /^[0-9a-zA-Z]([a-zA-Z0-9_])+$/ // ascii
      return pattern.test(v) || this.localText('general.invalidChars')
    }
  }
  private name: string = ''
  private robotType: string = ''
  private checkName!: (name: string) => boolean
  private valid: boolean = false
  private robotList = robots
  private extendedPedestal: boolean = false
  private additionalPedestalHeight: number = 0
  private fixedMachineSettings!: boolean
  private suggestedRobotType: string = ''
  private originalRobotType: string = ''
  private showConfirmRobotType: boolean = false
  private isNew!: boolean

  private localText (b: string): string {
    return String(this.$t(b))
  }

  get hintText() {
    return (this.suggestedRobotType === this.robotType && !this.showConfirmRobotType && !this.isNew)
        ? ''
        : this.$t('basicStep.hintTextSuggested') + this.suggestedRobotType
  }

  get extendedPedestalLabel (): string {
    if (this.robotType === RobotTypeEnum.RC10_UR) {
      return String(this.$t('basicStep.elecPedestal'))
    } else {
      return String(this.$t('basicStep.extdPedestal'))
    }
  }

  get encodedName (): string {
    return decodeURIComponent(this.name)
  }

  set encodedName (value: string) {
    this.name = encodeURIComponent(value)
  }

  get additionalPedestalHeightDisplayValue (): number | undefined {
    return this.units.toLocalLength(this.additionalPedestalHeight)
  }

  set additionalPedestalHeightDisplayValue (newHeight: number | undefined) {
    this.additionalPedestalHeight = this.units.toSystemLength(newHeight)
  }

  private getDefaultAdditionalPedestalHeight (): number {
    // set default values for additionalPedestalHeight
    if (this.robotType === RobotTypeEnum.RC10_UR) {
      return 700
    } else if (this.robotType === RobotTypeEnum.RI20_FANUC || this.robotType === RobotTypeEnum.RI20_KUKA) {
      return 280
    }
    return 0
  }

  private mounted () {
    this.name = this.value.name
    const ps = this.value.programSettings
    const ms = this.machineSettings
    this.initRobotType(this.value, ms)
    this.additionalPedestalHeight = (ps && ps.additionalPedestalHeight) ? ps.additionalPedestalHeight : (ms.additionalPedestalHeight || 0)
    this.extendedPedestal = this.additionalPedestalHeight > 0
    this.parentBus.$on('stepper_next', this.next)
  }

  private beforeDestroy () {
    this.parentBus.$off('stepper_next', this.next)
  }

  private next () {
    // console.log('[DEBUG] SimpleFormA emitting:', this.name, this.robotType)
    this.$emit('next', this.name, this.robotType)
  }

  // Watcher to emit valid state to "next" button in stepper
  @Watch('valid')
  private validWatcher (value: boolean) {
    this.$emit('validate', value)
  }

  @Watch('selectedEntity')
  private selectedEntityWatcher (value: PalletPattern) {
    this.name = value.name
    const ps = value.programSettings
    this.initRobotType(value, this.machineSettings)
    this.additionalPedestalHeight = (ps && ps.additionalPedestalHeight) ?
        ps.additionalPedestalHeight :
        (this.machineSettings.additionalPedestalHeight || 0)
    this.extendedPedestal = this.additionalPedestalHeight > 0
  }

  /**
   * RULES
   */
  private checkIfNameExists (value: string): boolean | string {
    if (!value) {
      return this.localText('general.required')
    }
    const nameFound = this.checkName(value)
    if (nameFound) {
      return this.localText('general.nameAlreadyExists')
    }
    return true
  }

  private translateUnit (unit: string): string {
    return String(this.$t('general.' + unit))
  }

  private isCustomSolution(): boolean {
    return RobotTypeEnum.CUSTOM_SOLUTION === this.robotType
  }

  private initRobotType (pattern: PalletPattern, ms: MachineSettings) {
    this.originalRobotType = this.getRobotTypeFromPattern(pattern)
    this.suggestedRobotType = (ms && ms.robotType) ? ms.robotType : ''
    if (this.originalRobotType !== '' && this.robotList.some(r => r.id === this.originalRobotType)) {
      this.robotType = this.originalRobotType
    } else {
      this.robotType = this.suggestedRobotType
      this.showConfirmRobotType = !this.isNew // only show for existing pattern with unavailable robot type
    }
  }

  private getRobotTypeFromPattern (pattern: PalletPattern) {
    const ps = pattern.programSettings
    return (ps && ps.robotType) ? ps.robotType : ''
  }

  private confirmRobotType() {
    this.showConfirmRobotType = false
  }

  private cancelConfirmation() {
    this.showConfirmRobotType = false
    this.$emit('cancel')
  }
}
